// EXP1-S5 (docs/build-briefs/EXP1-S5-export-consoles.md): the one download the franchisor console's export menus share. It
// fetches a file over the console session's bearer token and hands the blob to the browser. A 401 is reported so the
// caller can end the session; any other failure is "failed". The token never leaves this request.

export type DownloadOutcome = "ok" | "unauthorized" | "failed";

/** Hands a blob to the browser as a file download. */
export function saveBlob(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.append(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export async function downloadWithToken(
  path: string,
  token: string,
  fileName: string,
): Promise<DownloadOutcome> {
  try {
    const response = await fetch(path, { headers: { authorization: `Bearer ${token}` } });
    if (response.status === 401) return "unauthorized";
    if (response.status !== 200) return "failed";
    saveBlob(await response.blob(), fileName);
    return "ok";
  } catch {
    return "failed";
  }
}

/** CRB5: a download whose request carries a JSON body (a custom report's spec). Same outcomes as downloadWithToken. */
export async function downloadPostWithToken(
  path: string,
  token: string,
  body: unknown,
  fileName: string,
): Promise<DownloadOutcome> {
  try {
    const response = await fetch(path, {
      method: "POST",
      headers: { authorization: `Bearer ${token}`, "content-type": "application/json" },
      body: JSON.stringify(body),
    });
    if (response.status === 401) return "unauthorized";
    if (response.status !== 200) return "failed";
    saveBlob(await response.blob(), fileName);
    return "ok";
  } catch {
    return "failed";
  }
}
